module.exports = "<p>\n\n  A l'épicerie, vous trouverez de nombreux produits du terroir. Cidre, Escargots, Canard, Autruche, Entremets, Miel, Café...\n\n  <img src=\"/assets/images/thumb/resto/epicerie.jpg\" alt=\"epicerie\" class=\"epicerie\" />\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/bar-epicerie/bar-epicerie.component.html
// module id = 580
// module chunks = 1